__turbopack_context__.v({
  "phoneNumberDescription": "PhoneNumber-module-scss-module__gBiz2q__phoneNumberDescription",
});
